import { render, staticRenderFns } from "./NavbarSecondary.vue?vue&type=template&id=24454c46&scoped=true"
import script from "./NavbarSecondary.vue?vue&type=script&lang=js"
export * from "./NavbarSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24454c46",
  null
  
)

export default component.exports